export interface ITaskEditItemTaskPriority {
    id: string;
    code: string;
    sortOrder: number;
}

export class TaskEditItemTaskPriority implements ITaskEditItemTaskPriority {
    id: string;
    code: string;
    sortOrder: number;

    constructor();
    constructor(obj: ITaskEditItemTaskPriority);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.sortOrder = obj && obj.sortOrder || 0;
    }
}